<template>
  <article>
    <section class="xbed-sub-title">
      <span>智能硬件管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>门锁帐号管理</BreadcrumbItem>
        <BreadcrumbItem>门锁帐号列表</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="帐号名" :label-width="85">
          <Input v-model="search.userName" placeholder=""></Input>
        </FormItem>
        <FormItem label="关联门店" :label-width="85">
          <Select v-model="search.chainId" clearable filterable placeholder="输入下拉选择">
            <Option v-for="item in allChains" :value="item.chainId" :key="item.chainId">{{ `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button @click="queryAccountList">查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="showAddLockAdminDialogFn">新建帐号</Button>
        </FormItem>
      </Form>
      <Table :columns="columns" :data="lockAccountlist"></Table>
      <div style="margin: 10px;">
        <Page :total="page.total" show-sizer :current="page.page" :page-size="page.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
    </section>
    <Modal v-model="modalStatus.visable" ref="accountModal" :loading="true" :title="modalStatus.isEdit?'修改帐号':'新建帐号'" @on-ok="saveAccountMsgFn">
      <Form :model="lockAccountMsg" label-position="left" :rules="lockAccountValidate" ref="editForm">
        <FormItem label="门锁型号" :label-width="150" prop="lockModelId">
          <Select v-model="lockAccountMsg.lockModelId" :disabled="modalStatus.isEdit" :class="modalStatus.isEdit?'':'addAcSelectStyle'">
            <Option v-for="item in lockModelList" :key="item.lockModelId" :value="item.lockModelId">{{item.modelName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="帐号" :label-width="150" prop="account">
          <Input v-model="lockAccountMsg.account" :maxlength="50" :disabled="modalStatus.isEdit" :class="modalStatus.isEdit?'':'addAcInputStyle'"></Input>
          <span class="acTxtStyle" v-if="!modalStatus.isEdit && lockAccountMsg.lockModelId === 12">xbed_</span>
        </FormItem>
        <FormItem label="状态" prop="state" :label-width="150" v-if="modalStatus.isEdit" required>
          <RadioGroup v-model="lockAccountMsg.state">
              <Radio :label="1" >启用</Radio>
              <Radio :label="0" >停用</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem label="密码/秘钥" :label-width="150" prop="password">
          <Input v-model="lockAccountMsg.password" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="联系人" :label-width="150" prop="contact">
          <Input v-model="lockAccountMsg.contact" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="手机号" :label-width="150" prop="telephone">
          <Input v-model="lockAccountMsg.telephone" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="关联门店" :label-width="150" prop="chainId">
          <Select v-model="lockAccountMsg.chainId" clearable filterable placeholder="门店名称 输入下拉选择">
            <Option v-for="item in allChains" :value="item.chainId" :key="item.chainId">{{ `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
        </FormItem>
        <FormItem label="地址备注" :label-width="150" prop="addressRemark">
          <Input v-model="lockAccountMsg.addressRemark" :maxlength="50"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal v-model="relativeLockModal" title="帐号关联门锁" width="1000" footer-hide>
      <Table :columns="lockColumns" :data="locklist" :style="lockPage.hadGetResult?'display:block':'display:none'"></Table>
      <div style="margin: 10px;">
        <Page :total="lockPage.total" show-sizer :current="lockPage.page" :page-size="lockPage.pageSize" @on-change="adminLockChangePage" @on-page-size-change="adminLockChangePageSize"></Page>
      </div>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
import {phoneRegular} from '@/utils/regular'
import {STORE_KEY} from "../../../constants";

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.env = Utils.findFromLocalStorage("env", "dev");

    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      'isForm': true,
      // 'group': 'dev' // 本地请求才需要加该参数
    }

    this.queryAccountList()
    this.queryLockModel();
    // this.deleteBtnVisable = this.checkHasPermission('lockAccount')
  },

  async mounted() {
		this.getChainData();
  },

  data (){
    return {
      // deleteBtnVisable: false,
      lockModelList: [],
      lockAccountMsg: {},
      modalStatus: {
        visable: false,
        isEdit: false,
      },
      search:{
        userName:'',
        chainId:''
      },
      page: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      lockAccountlist:[],
      allChains: [],
      columns: [
        {
          title: 'ID',
          width: 120,
          align: 'center',
          key: 'userId'
        },
        {
          title: '帐号',
          width: 150,
          align: 'center',
          key: 'userName'
        },
        {
          title: '状态',
          width: 120,
          align: 'center',
          render: (h, param) => {
            return h('Tag', {
              props: {
                color: param.row.state ? 'green' : 'red'
              }
            }, param.row.state ? '启用' : '停用')
          }
        },
        {
          title: '联系人',
          width: 150,
          align: 'center',
          key: 'contacts'
        },
        {
          title: '手机号',
          width: 150,
          align: 'center',
          key: 'contactPhone'
        },
        {
          title: '关联门店',
          width: 200,
          align: 'center',
          key: 'chainName'
        },
        {
          title: '地址备注',
          width: 200,
          align: 'center',
          key: 'chainAddress'
        },
        {
          title: '操作',
          width: 300,
          align: 'center',
          render: (h, param)=> {
            return h('div', [
              h('i-button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if (!this.checkHasPermission('lockAccountEdit')) {
                      return;
                    }
                    this.modalStatus = {
                      visable: true,
                      isEdit: true
                    }
                    this.resetField()
                    this.lockAccountMsg = {
                      lockModelId: param.row.lockModelId,
                      userId: param.row.userId,
                      account: param.row.userName,
                      password: param.row.passWord,
                      contact: param.row.contacts,
                      telephone: param.row.contactPhone,
                      chainId: param.row.chainId,
                      chainName: param.row.chainName,
                      addressRemark: param.row.chainAddress,
                      state: param.row.state
                    }
                    console.log('edit lockAccountMsg=======', this.lockAccountMsg)
                  }
                }
              }, '编辑'),
              // !this.deleteBtnVisable?'':
              // h(
              //   "Button",
              //   {
              //     props: {
              //     type: "error",
              //     size: "small"
              //   },
              //     style: {
              //     marginLeft: '5px',
              //   },
              //     on: {
              //       click: () => {
              //         if (!this.checkHasPermission('lockAccountDel')) {
              //           return;
              //         }
              //         this.$Modal.confirm({
              //           render: modalH => {
              //             let modalText = `确定删除门锁帐号： ${param.row
              //               .userName} 吗？\n一经确定将无法修改`;
              //             return modalH(
              //               "div",
              //               {
              //                 style: {
              //                   fontSize: "16px"
              //                 }
              //               },
              //               modalText
              //             );
              //           },
              //           onOk: () => {
              //             this.deleteLockAccountByIdFn(param.row.userId,param.row.userName);
              //           }
              //         });
              //       }
              //     }
              //   }, "删除"),
              h('i-button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    if (!this.checkHasPermission('locks')) {
                      return;
                    }
                    this.showRelativeLockDialogFn(param.row.userId)
                  }
                }
              }, '门锁列表') 
            ])
          }
        },
      ],
      lockAccountValidate: {
        account: [
          { required: true, message: '请填写帐号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          {
            pattern: phoneRegular,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        chainId: [
          { required: true, message: '请选择门店'}
        ],
        addressRemark: [
          { required: true, message: '请填写地址备注', trigger: 'blur' }
        ]
      },
      relativeLockModal: false,
      locklist:[],
      lockPage: {
        total: 0,
        page: 1,
        pageSize: 10,
        userId: '',
        hadGetResult: false
      },
      lockColumns: [
        {
          title: '网关',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, ['无','有'][param.row.hasGateway])
          }
        },
        {
          title: '门锁编码',
          width: 200,
          align: 'center',
          key: 'lockName'
        },
        {
          title: '门锁别名',
          width: 200,
          align: 'center',
          key: 'lockAlias'
        },
        {
          title: 'mac地址',
          width: 200,
          align: 'center',
          key: 'lockMac'
        },
        {
          title: '电量',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span', {}, `${param.row.electricQuantity}%`)
          }
        }
      ],
      stateType:[{key:1, value:"启用"}, {key:0, value:"停用"}]
    }
  },

  methods: {
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    async queryLockModel() {
      let resp = (await API.omsAPI[this.env].deviceModule.queryLockModel(this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取门锁型号失败',
          desc: resp.msg
        })
        return
      }
      this.lockModelList = resp.lockModelList.filter(item => item.lockModelId > 11);
    },

    // 获取所有门店数据
    async getChainData () {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询门店列表失败",
          desc: resp.msg
        });
        return
      }
      this.allChains = resp;
    },

    changePage(page) {
      this.page.page = page;
      this.queryAccountList();
    },

    changePageSize(pageSize) {
      this.page.page = 1;
      this.page.pageSize = pageSize;
      this.queryAccountList();
    },

    async queryAccountList(){
      if (!this.checkHasPermission('lockAccount')) {
        return;
      }
      try {
        let params= {
          userName: this.search.userName,
          chainId: this.search.chainId,
          page: this.page.page,
          size: this.page.pageSize,
        }
   
        let resp = (await API.omsAPI[this.env].clientServer.getAllLockAdmin(params, this.protHeaders)).data;
        if ( resp.retCode ) {
          this.$Notice.error({
            title: '获取页面数据失败',
            desc: resp.msg
          })
          return
        }
        console.log('queryAccountList========', resp)
        this.page.total = resp.total;
        this.lockAccountlist = resp.list
      } catch (e) {
        this.$Notice.error({
					title: '操作失败，请稍后再试'
        })
      }
    },

    showAddLockAdminDialogFn() {
      if (!this.checkHasPermission('lockAccountCreate')) {
        return;
      }
      this.modalStatus = {
        visable: true,
        isEdit: false
      }
      this.resetField()
      this.lockAccountMsg = {
        lockModelId: 12,
        account: '',
        password: '',
        contact: '',
        telephone: '',
        chainId: '',
        chainName: '',
        addressRemark: '',
        state: 1
      }
    },

    resetField(){
      this.$refs.editForm.resetFields();
    },

    saveAccountMsgFn() {
      this.$refs.accountModal.buttonLoading = false;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          for (let a = 0; a < this.allChains.length; a++) {
            if (this.allChains[a].chainId == this.lockAccountMsg.chainId) {
              this.lockAccountMsg.chainName = this.allChains[a].chainName
              break 
            }
          }
          if (this.modalStatus.isEdit == false) {
            this.addNewAccountFn()
          } else {
            this.editAccountFn()
          }
        }
      })
    },

    async addNewAccountFn() {
      let params = {
        lockModelId: this.lockAccountMsg.lockModelId,
        userName: this.lockAccountMsg.account,
        passWord: this.lockAccountMsg.password,
        contacts: this.lockAccountMsg.contact,
        contactPhone: this.lockAccountMsg.telephone,
        chainId: this.lockAccountMsg.chainId,
        chainName: this.lockAccountMsg.chainName,
        chainAddress: this.lockAccountMsg.addressRemark,
        state: this.lockAccountMsg.state
      }
      let resp = (await API.omsAPI[this.env].clientServer.addLockAdmin(params, this.protHeaders)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '增加门锁帐号失败',
          desc: resp.msg
        })
        return
      }
      this.modalStatus.visable = false;
      this.$Notice.success({
        title: '添加成功',
      })
      this.queryAccountList()
    },

    async editAccountFn() {
      let params = {
        lockModelId: this.lockAccountMsg.lockModelId,
        userId: this.lockAccountMsg.userId,
        userName: this.lockAccountMsg.account,
        passWord: this.lockAccountMsg.password,
        contacts: this.lockAccountMsg.contact,
        contactPhone: this.lockAccountMsg.telephone,
        chainId: this.lockAccountMsg.chainId,
        chainName: this.lockAccountMsg.chainName,
        chainAddress: this.lockAccountMsg.addressRemark,
        state: this.lockAccountMsg.state
      }
      let res = (await API.omsAPI[this.env].clientServer.modifyLockAdmin(params, this.protHeaders)).data;

      if (res) {
        this.$Notice.success({
          title: '操作成功'
        })
        this.queryAccountList()
        this.modalStatus.visable = false;
      } else {
        this.$Notice.error({
          title: '操作失败',
          desc: res.msg
        })
      }
    },

    async deleteLockAccountByIdFn(userId,username) {
      console.log('deleteLockAccountByIdFn======', userId)
      let params = {
        userId: userId,
        username: username
      }
      let headerapi =  this.protHeaders
      headerapi.isForm = false
      let resp = (await API.omsAPI[this.env].clientServer.deleteLockAdmin(params, headerapi)).data;
      if (resp.retCode){
        this.$Notice.error({
          title: "删除失败",
          desc: resp.msg
        });
        return
      }
      this.$Notice.success({
        title: "删除成功",
        desc: resp.msg
      });
      this.queryAccountList()
    },

    showRelativeLockDialogFn(userId) {
      this.lockPage.hadGetResult = false
      this.relativeLockModal = true
      this.lockPage.userId = userId
      this.queryLockList()
    },

    adminLockChangePage(page) {
      // this.locklist = []
      this.lockPage.page = page;
      this.queryLockList();
    },

    adminLockChangePageSize(pageSize) {
      // this.locklist = []
      this.lockPage.page = 1;
      this.lockPage.pageSize = pageSize;
      this.queryLockList();
    },

    async queryLockList(){
      try {
        let params= {
          userId: this.lockPage.userId,
          pageNo: this.lockPage.page,
          size: this.lockPage.pageSize,
        }
   
        let resp = (await API.omsAPI[this.env].clientServer.getAdminLocklist(params, this.protHeaders)).data;
        if ( resp.retCode ) {
          this.$Notice.error({
            title: '获取页面数据失败',
            desc: resp.msg
          })
          return
        }
        console.log('queryLockList========', resp)
        this.lockPage.total = resp.total;
        this.locklist = resp.list
        this.lockPage.hadGetResult = true
      } catch (e) {
        this.$Notice.error({
					title: '操作失败，请稍后再试'
        })
      }
    },
    
  }
}
</script>

<style lang="scss">
.addAcInputStyle {
  position: relative;
  padding-left: 50px;
}
.ivu-select-disabled .ivu-select-selection{
  background-color: #ccc;
  color: #000;
}
.acTxtStyle {
  position: absolute;
  display: block;
  width: 50px;
  bottom: 0;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/smart-device/lock-account-manage/index.vue